import { KnownUserStatus } from '@groundfloor-platform/mgmt-service-g-sdk';

/**
 * The statuses a user badge renders.
 *
 * `rejected` is a courier's access level, not a status — their status is `inactive`, as a suspended
 * courier's is. It lives here because the badge is the only place the two can be told apart.
 */
export type BadgeUserStatus = KnownUserStatus | 'rejected';

/** What a rejected courier is badged as, so the maps and their callers cannot drift. */
export const REJECTED_BADGE_STATUS = 'rejected';
